import { render } from "./PartnerShow.vue?vue&type=template&id=106d9acb"
import script from "./PartnerShow.vue?vue&type=script&lang=js"
export * from "./PartnerShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__